import axios from 'axios';

const hostname = process.env.VUE_APP_API_URL || 'http://localhost:3000';

const instance = axios.create({
  baseURL: hostname,
});

export default instance;
